import { StyleSheet } from '@react-pdf/renderer';
const styles = StyleSheet.create({
  back: {
    width: '100%',
    height: '80vh'
  },
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35
  },
  title: {
    fontSize: 24,
    textAlign: 'center',
    fontFamily: 'Oswald'
  },
  author: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 10
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
    fontFamily: 'Oswald'
  },
  text: {
    margin: 12,
    fontSize: 14,
    textAlign: 'justify',
    fontWeight: 600,
    letterSpacing: 1
  },
  imageLogo: {
    maxWidth: '48%',
    minHeight: 100,
    width: '48%',
    flexBasis: '50%'
  },
  image: {
    maxWidth: '24%',
    minHeight: 50,
    width: '24%',
    flexBasis: '25%'
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: 'center',
    color: 'grey'
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey'
  },
  content: {
    textAlign: 'justify',
    marginLeft: 12,
    fontSize: 12
  },
  textReport: {
    marginTop: 12,
    marginLeft: 12,
    marginBottom: 12,
    fontSize: 14,
    textAlign: 'justify',
    fontWeight: 700
  },
  textContent: {
    textAlign: 'justify',
    marginLeft: 12,
    fontSize: 10,
    marginBottom: 7
  },
  viewFlex: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'space-around'
  },
  viewAttachmentFlex: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'flex-start'
  },
  textAttachment: {
    fontSize: 12,
    marginBottom: 7,
    marginLeft: 12
  }
});
export default styles;